<template>
  <div class="w-full lg:w-2/5">
    <p class="mb-6 text-sm pb-6 border-b">
      You can change your user details in the
      <router-link to="/profile-v2" class="no-underline text-grey-darkest border-b pb-1">profile</router-link>
      section
    </p>
    <div class="flex inline-block">
      <h2 class="uppercase font-bold mb-5 border-solid border-r border-black pr-8">Presenter Info</h2>
      <input id="presenterInfo" type="checkbox" class="blue" v-model="presenterinfo" />
      <label for="presenterInfo" class="bg-white ml-8 mt-1 text-xs font-semibold">Display</label>
    </div>

    <div class="flex flex-col mb-6">
      <label class="text-xs uppercase mb-2">Presenter Name:</label>
      <input :value="profile.name" readonly class="bg-white outline-none rounded p-2 shadow border" />
    </div>

    <div class="flex flex-col mb-6">
      <label class="text-xs uppercase mb-2">Position Held:</label>
      <input
        :value="profile.position"
        readonly
        class="bg-white outline-none rounded p-2 shadow border"
      />
    </div>
  </div>
</template>

<style scoped>
.panel {
  @apply w-128 p-6;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PresenterInfo',

  props: ['value'],

  computed: {
    ...mapState(['profile']),

    presenterinfo: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
